/**
 * Normalizes CRM sync API responses for menu / external-sync buttons.
 * Receipt sync returns `{ success: true }`; some legacy paths may use `{ done: true }` or bare boolean.
 */
export function isSyncActionSuccess(response: unknown, successKey = 'success'): boolean {
  if (response === true) {
    return true;
  }
  if (response === false || response == null) {
    return false;
  }
  if (typeof response === 'object') {
    const r = response as Record<string, unknown>;
    if (r[successKey] === true) {
      return true;
    }
    if (r.done === true) {
      return true;
    }
  }
  return false;
}
